import { OrderDocumentModel } from '@onrunning/backstage-models';
import { OrderDocumentType } from './order-document-type.enum';

export class OrderDocument extends OrderDocumentModel {
  public displayName?: string;
  public description?: string;
  public loading?: boolean;

  public orderDocumentType?: OrderDocumentType;
}
